module.exports = __webpack_public_path__ + "img/transfer.24e8c493.svg";